import { render, staticRenderFns } from "./personWithdraw.vue?vue&type=template&id=cdcbb482&scoped=true&"
import script from "./personWithdraw.vue?vue&type=script&lang=js&"
export * from "./personWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./personWithdraw.vue?vue&type=style&index=0&id=cdcbb482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcbb482",
  null
  
)

export default component.exports